import { render, staticRenderFns } from "./TdxScrollContainer.vue?vue&type=template&id=6cbfd806&scoped=true&"
import script from "./TdxScrollContainer.vue?vue&type=script&lang=js&"
export * from "./TdxScrollContainer.vue?vue&type=script&lang=js&"
import style0 from "./TdxScrollContainer.vue?vue&type=style&index=0&id=6cbfd806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbfd806",
  null
  
)

export default component.exports